import React from 'react';
import MuiTooltip from '@material-ui/core/Tooltip';
import { pxToRem } from '../../../../styles/themes/vad/constants';
import { withStyles } from '@material-ui/core/styles';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import { borderRadius } from '../../../../styles/themes/vad/borderRadius';

const CustomTooltip = withStyles(theme => {
  const tooltipBorder = `${pxToRem(1)} solid ${theme.mixins.Grey(200)}`;

  return {
    tooltip: {
      backgroundColor: theme.mixins.White(),
      maxWidth: 'none',
      border: tooltipBorder,
      borderRadius: borderRadius.b2Rem,
      boxShadow: `0 6px 12px ${theme.mixins.Black(175)}` //'0 6px 12px rgba(0,0,0,.175)',
    },
    arrow: {
      overflow: 'initial',
      width: pxToRem(24),
      height: pxToRem(24),
    },
    popper: {
      pointerEvents: 'initial',
    },
    popperArrow: {
      '&[x-placement*="bottom"] .MuiTooltip-arrow': {
        marginTop: pxToRem(-19),
        '&:before': {
          borderLeft: tooltipBorder,
          borderTop: tooltipBorder,
        },
      },
      '&[x-placement*="top"] .MuiTooltip-arrow': {
        color: theme.mixins.White(),
        margin: pxToRem(0),
        marginBottom: pxToRem(-24),
        '&:before': {
          borderBottom: tooltipBorder,
          borderRight: tooltipBorder,
        },
      },
    },
  };
})(MuiTooltip);

const Tooltip = props => {
  const { titleNode, children, className } = props;
  const [open, setOpen] = React.useState(false);
  const handleTooltipClose = () => {
    setOpen(false);
  };

  const handleTooltipOpen = () => {
    setOpen(!open);
  };

  return (
    <ClickAwayListener onClickAway={handleTooltipClose}>
      <CustomTooltip
        onClose={handleTooltipClose}
        open={open}
        disableHoverListener
        disableTouchListener
        placement="top"
        arrow
        title={titleNode}
        classes={{
          popper: className,
        }}
      >
        <div onClick={handleTooltipOpen}>{children}</div>
      </CustomTooltip>
    </ClickAwayListener>
  );
};

export default Tooltip;
